/*
  Het bedrag in de afrekenknop van de tas (29-10-2026, naar kovak.pl).
  Broadcast ververst na een wijziging de regels en het overzicht, maar niet
  het formulier met de knop. Dus hier na elke theme:cart:change het totaal
  uit /cart.js halen. In de valuta van de bezoeker, zoals cart.js die geeft.
*/
(function () {
  function zet() {
    var plekken = document.querySelectorAll('[data-tas-knop-totaal]');
    if (!plekken.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var tekst = new Intl.NumberFormat('en-GB', { style: 'currency', currency: c.currency }).format(c.total_price / 100);
        [].forEach.call(plekken, function (p) { p.textContent = tekst; });
      })
      .catch(function () {});
  }
  document.addEventListener('theme:cart:change', zet);
  document.addEventListener('theme:cart-drawer:open', zet);
})();

/*
  Productpagina (29-10-2026, zijn wensen na de eerste preview):
  - de link "Size Chart" in de legend naast "Size" in plaats van erboven;
  ("Details" heet sinds 29-10 "Description" en staat ook op mobiel open, zijn wens.)
  Verplaatsen in plaats van in de snippets omschrijven: brand-maattabel en
  het reviewblok blijven zo ongemoeid, en hun eigen luisteraars gaan mee.
*/
(function () {
  function schik() {
    [].forEach.call(document.querySelectorAll('.selector-wrapper--size'), function (w) {
      var link = w.querySelector(':scope > .brand-maattabel');
      var legend = w.querySelector('.radio__legend');
      if (link && legend) legend.appendChild(link);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schik); else schik();
})();


/*
  Producttitel altijd binnen twee regels (29-10-2026, zijn wens): is hij langer,
  dan stap voor stap 1 px kleiner tot hij past, met 14 px als ondergrens. Opnieuw
  bij een andere schermbreedte en zodra het lettertype geladen is, want Cardo
  is breder dan de terugval en geeft dus een andere regelval.
*/
(function () {
  function pas() {
    var t = document.querySelector('.product__head .product__title');
    if (!t) return;
    t.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(t).fontSize);
    var lh = parseFloat(getComputedStyle(t).lineHeight) / fs || 1.2;
    while (t.getBoundingClientRect().height > fs * lh * 2 + 2 && fs > 14) {
      fs -= 1;
      t.style.fontSize = fs + 'px';
    }
  }
  var wacht;
  window.addEventListener('resize', function () { clearTimeout(wacht); wacht = setTimeout(pas, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pas);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pas); else pas();
})();
